import React from 'react'
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import { ChatMessageType } from '../types'
import '../Chat.css'

type ChatMessageProps = {
  type: ChatMessageType
  text: string
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ type, text }) => {
  const className = `chat-message chat-message--${type}`
  const testId = `chat-message-${type}`

  return (
    <div className={className} data-testid={testId}>
      <span
        className="chat-message__text"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(marked.parse(text) as string) }}
      />
    </div>
  )
}
